export default __webpack_public_path__ + "static/media/minus.6eb8af26.svg";